import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const AuthSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const handleAuthSuccess = () => {
      try {
        // Get token and user data from URL fragment
        const fragment = window.location.hash.substring(1);
        const params = new URLSearchParams(fragment);
        
        const token = params.get('token');
        const userBase64 = params.get('user');
        
        if (!token || !userBase64) {
          throw new Error('Missing authentication data');
        }

        // Decode user data
        const userJson = atob(userBase64);
        const user = JSON.parse(userJson);

        if (!user.id || !user.email || !user.name) {
          throw new Error('Invalid user data');
        }

        // Store authentication data
        login(token, user);
        
        // Clear the URL fragment for security
        window.history.replaceState({}, document.title, '/admin');
        
        // Navigate to admin
        navigate('/admin', { replace: true });
        
      } catch (error) {
        console.error('Auth success error:', error);
        navigate('/login?error=auth_failed', { replace: true });
      }
    };

    handleAuthSuccess();
  }, [login, navigate]);

  return (
    <div className="oauth-callback-container">
      <div className="oauth-callback-card">
        <div className="spinner"></div>
        <h2>Authentication Successful</h2>
        <p>Redirecting to admin portal...</p>
      </div>
    </div>
  );
};